module.exports = __webpack_public_path__ + "static/media/auth-img.df378980.jpg";